export default "__VITE_ASSET__DEzJ0tjN__"